export default class HttpException extends Error {
  constructor(name, message, ...args) {
    super(...args)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpException)
    }

    this.name = name
    this.message = message
  }
}
